import PosterRow from "src/components/posterrow/PosterRow";
import { type StreamingContent } from "src/lib/movieinfo/movieinfotypes";
import classNames from "classnames";
import styles from "./SimilarStreamingTitles.module.css";


//#region [Props]
type SimilarStreamingTitlesProps = {
	similarContent: StreamingContent[];
	className?: string;
};
//#endregion

//#region [Component]
export default function SimilarStreamingTitles({ similarContent, className }: SimilarStreamingTitlesProps) {
	return <section className={classNames(styles.SSimilarStreamingTitles, className)}>
		<h1 className={styles.SHeading}>Lignende titler</h1>
		<PosterRow posterList={similarContent} renderPlaceholders max={6} />
	</section>;
}
//#endregion
